module.exports = __webpack_public_path__ + "img/footer_toggle_1.be9add79.png";